import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Card } from 'react-bootstrap';

const FeedCardSkeleton = ({ count = 3 }) => {
  return Array(count).fill().map((_, idx) => (
    <Card className="mb-4 border-0 shadow-sm rounded-4 overflow-hidden" key={idx}>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div className="d-flex">
            <Skeleton circle height={45} width={45} />
            <div className="ms-2">
              <Skeleton height={14} width={100} />
              <Skeleton height={12} width={60} />
            </div>
          </div>
          <Skeleton height={30} width={80} borderRadius={20} />
        </div>

        <Skeleton count={2} height={14} className="mb-2" />

        <Skeleton height={400} className="rounded mb-2" />

        <div className="d-flex justify-content-between mt-2">
          <Skeleton width={100} height={20} />
          <Skeleton width={60} height={20} />
        </div>
      </Card.Body>
    </Card>
  ));
};

export default FeedCardSkeleton;